export default __webpack_public_path__ + "static/media/s1.102d86e6.png";